import {
    apiRequest,
    AwardPeriodList,
    AwardPeriodInactive
} from "../../../../../services/adapters/kepegawaian/penghargaanService"

class DataTableRepository {

    fetchRowTable = async (query, cancelToken) => {
        return await apiRequest("get", AwardPeriodList, {
            cancelToken: cancelToken,
            params: query
        }, true)
    }

    fetchInactive = async (query) => {
        return await apiRequest("post", AwardPeriodInactive, {
            body: query
        }, true)
    }

}

export default DataTableRepository